export default "__VITE_ASSET__DWZhsidE__"